export default {
  loading: 'Loading ...',
} as const;
